import { Component, Input } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';
import { TimepickerConfig } from 'ngx-bootstrap/timepicker';

@Component({
    selector: 'detail-info-time-picker',
    templateUrl: './detail-info-time-picker.component.html',
    standalone: false
})
export class DetailInfoTimePickerComponent extends DetailInfoTypeComponent {
  @Input() bsConfig: Partial<TimepickerConfig>;

  ngOnInit() {
    super.ngOnInit();
  }

}